import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import RegistrationForm, { ValidationInterface } from "../components/profile/RegistrationForm";
import { useFreeUpgradeTier, validateDob, validateEmail, validateMobile, validateRequired } from "../services/helpers";
import {assignFreeUpgradeTierToUser} from "../services/user";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import VerifyEmail from "../components/VerifyEmail";
import { profile } from "console";
import FreeTierUpgradeForm from "../components/profile/FreeTierUpgradeForm";
import {RegistrationFormType} from "../constants";

const RegistrationFreeTierUpgrade = () => {
    const navigate = useHistory();
    const { t, i18n } = useTranslation();
    const { user } = useAuth0();
    const { getFreeUpgradeTier, clearFreeUpgradeTier, getFreeTierUpgradeToken, clearFreeTierUpgradeToken } = useFreeUpgradeTier();
    const [freeUpgradeTier, setFreeUpgradeTier] = useState(null);
    const [freeTierUpgradeToken, setFreeTierUpgradeToken] = useState(null);
    const [validations, setValidations] = useState<ValidationInterface>({
        salutations: [validateRequired],
        first_name: [validateRequired],
        last_name: [validateRequired],
        gender: [validateRequired],
        _custom: [
            formData => validateRequired('date_of_birth', formData.year, formData.month),
            formData => validateDob('date_of_birth', formData.year, formData.month),
        ]
    });

    const beforePatch = data => {
        let freeTierUpgradeData = { membership_tier: freeUpgradeTier };
        return { ...data, ...freeTierUpgradeData };
    };

    const afterSubmit = ({ success }) => new Promise<string>(async (resolve) => {
        if (!success) return resolve(null);
        const res = await assignFreeUpgradeTierToUser(freeTierUpgradeToken, user.email); // api
        if (res.success) {
            clearFreeTierUpgradeToken();
            clearFreeUpgradeTier();
            navigate.push(`/${i18n.language}/registration-success`, {
                state: {
                    tier: freeUpgradeTier,
                }
            });
            return resolve(null);
        } else {
            return resolve(t('error.profile_migrate_failure'));
        }
    });

    const beforeNext = (current, next) => {
        let rules = { ...validations };
        if (next === 1) {
            rules.email = [validateRequired, validateEmail];
            rules.mobile = [validateRequired, validateMobile];
            rules.house_or_building_estate = [validateRequired];
            rules.road_or_street = [validateRequired];
            rules.district = [validateRequired];
            rules.country = [validateRequired];
        }
        if (next === 2) {
            rules._custom.push(formData => !formData.consent ? t('error.missing_tnc') : null);
            rules._custom.push(formData => !formData.confirm_email ? t('error.confirmedEmailIsCorrect') : null);
        }
        setValidations(rules);
        return true;
    }

    const beforePrev = (current, prev) => {
        let rules = { ...validations };
        if (prev === 0) {
            delete rules.email;
            delete rules.mobile;
            delete rules.house_or_building_estate;
            delete rules.road_or_street;
            delete rules.district;
            delete rules.country;
        }
        if (prev === 1) {
            rules._custom.splice(2, 2);
        }
        setValidations(rules);
        return true;
    }

    useEffect(() => {
        if (!user) return;
        setFreeUpgradeTier(getFreeUpgradeTier());
        setFreeTierUpgradeToken(getFreeTierUpgradeToken());
    }, [user]);

    return (
        <>
            {freeUpgradeTier && freeTierUpgradeToken && (<>

                {/* {user?.email_verified &&  */}
                    <RegistrationForm
                        validations={validations}
                        labelsWithStar={{'date_of_birth': true}}
                        beforePatch={beforePatch}
                        beforeNext={beforeNext}
                        beforePrev={beforePrev}
                        afterSubmit={afterSubmit}
                        formType={RegistrationFormType.FREE_TIER_UPGRADE}
                    />
                 {/* } */}
            </>)}

            {(!freeUpgradeTier || !freeTierUpgradeToken )&& <FreeTierUpgradeForm />}
        </>
    );
};

export default RegistrationFreeTierUpgrade;
